package fr.manyverse.app.presentation.components.modules.whiteboard

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import fr.manyverse.app.domain.model.WhiteboardAction
import fr.manyverse.app.domain.model.WhiteboardColor

@Composable
internal fun WhiteboardReadOnlyCanvas(
    strokes: List<WhiteboardAction.Stroke>,
    showGrid: Boolean,
    modifier: Modifier = Modifier
) {
    WhiteboardCanvas(
        strokes = strokes,
        showGrid = showGrid,
        isDrawingEnabled = false,
        currentColor = WhiteboardColor.BLACK,
        currentStrokeWidth = 4f,
        currentTool = WhiteboardTool.PEN,
        onStrokeComplete = {},
        modifier = modifier
    )
}